import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './DropdownLoadingContent-style.scss';

const DropdownLoadingContent = () => {
    return (
        <div className={styles.dropdownLoadingContent}>
            <Spinner dark />
        </div>
    );
};

export default DropdownLoadingContent;
